import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';
import { CircleInformation, FormRefresh } from 'grommet-icons';
import { useAppTheme } from '@Components/Context';
import { Spinning } from '@Components/Control';

const InfoNotice = ({
  header,
  headerColor = '#174EA6',
  text = null,
  textColor = 'var(--page-primary-text)',
  backgroundColor = '#D7EDFF',
  borderColor = '#61AFEE',
  isLoader = false,
  showRefresh = false,
  children = null,
  noMargin = false,
  noBottomMargin = false,
}) => {
  const { theme: { page }, isDarkMode } = useAppTheme();

  const useHeaderColor = isDarkMode ? page.highlight : headerColor;
  const useBg = isDarkMode ? page.altBg : backgroundColor;
  const useBorderColor = isDarkMode ? page.inputBorder : borderColor;
  const useTextColor = isDarkMode ? page.modalText : textColor;

  const renderIcon = () => {
    if (isLoader) {
      return (
        <Box>
          <Spinning size="small" color={page.highlight} />
        </Box>
      );
    }
    return <CircleInformation color={useHeaderColor} size="0.9rem" />;
  };

  const margin = (() => {
    if (noBottomMargin) {
      return { horizontal: noMargin ? '0' : '1.5rem', bottom: '0' };
    }
    if (noMargin) {
      return { bottom: '0.5rem' };
    }
    return { horizontal: '1.5rem', bottom: '0.5rem' };
  })();

  return (
    <Box
      background={useBg}
      border={{
        color: useBorderColor, size: '1px', side: 'all', style: 'solid',
      }}
      round="10px"
      direction="column"
      align="start"
      justify="center"
      gap="0.4rem"
      pad={{ vertical: '0.65rem', horizontal: '1rem' }}
      margin={margin}
    >
      <Box width="100%" direction="row" align="center" gap="0.35rem">
        {renderIcon()}
        <Text color={useHeaderColor} weight={600} size="0.9rem">{header}</Text>
        {showRefresh && (
          <Box flex direction="row" align="center" justify="end">
            <Box
              direction="row"
              align="center"
              gap="0.25rem"
              style={{ cursor: 'pointer' }}
              onClick={() => window.location.reload()}
            >
              <Text color={useHeaderColor} weight={600} size="0.9rem">
                Refresh
              </Text>
              <FormRefresh color={useHeaderColor} size="1.1rem" />
            </Box>
          </Box>
        )}
      </Box>
      {children || <Text color={useTextColor} size="0.9rem">{text}</Text>}
    </Box>
  );
};

InfoNotice.propTypes = {
  header: PropTypes.string.isRequired,
  headerColor: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  isLoader: PropTypes.bool,
  showRefresh: PropTypes.bool,
  children: PropTypes.node,
  noMargin: PropTypes.bool,
  noBottomMargin: PropTypes.bool,
};

export default InfoNotice;
